var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dsh-empty",class:{ 'dsh-empty--compact': _vm.compact },style:(_vm.minHeight ? { minHeight: _vm.minHeight + 'px' } : null)},[_c('p',{staticClass:"dsh-empty__title"},[_vm._v(_vm._s(_vm.title))]),(_vm.text)?_c('p',{staticClass:"dsh-empty__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }